import { client } from './client'

const uploadImage = async (data) => {
  try {
    let response = await client.post('/v1/upload', data)
    return response.data
  } catch (error) {
    throw new Error((error.response && error.response.data && error.response.data.message) || '')
  }
}

export {
  uploadImage
}



// WEBPACK FOOTER //
// ./src/api/routing-lambda/index.js